import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FaLink, FaGithub } from "react-icons/fa";
import "react-lazy-load-image-component/src/effects/blur.css";
import { FaArrowLeft } from "react-icons/fa";

const WorkDetail = () => {
  const { slug } = useParams();
  const [work, setWork] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const URL = process.env.REACT_APP_API_URL;

  const technologies = work && work.Technologies;

  const images = work && work.image;

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  const currentImg = images && images[currentIndex];

  useEffect(() => {
    axios
      .get(`${URL}/works/${slug}`)
      .then((respnse) => {
        setWork(respnse.data);
        console.log(setWork);
        console.log("setWork");
      })
      .catch((error) => {
        console.error("Error fetching work item:", error);
      });
  }, [slug, URL]);

  return (
    <>
      {work && (
        <div className="app__projects-all">
          <div className="work__detail">
            <div className="prev-pg">
              <Link onClick={goBack} className="prev-pg-link">
                <FaArrowLeft />
              </Link>
            </div>
            <div className="work__detail-img">
              <LazyLoadImage
                src={currentImg.image}
                alt={work.title}
                className=""
              />
              <p className="work__detail-project-title">{work.title}</p>

              <div className="work__detail-project-links">
                <a href={work.project_link} className="">
                  Live <FaLink />
                </a>
                <a href={work.code_link} className="">
                  Code <FaGithub />
                </a>
              </div>
            </div>

            <div className="work__detail-description">
              <p className="work__detail-btext">About this project</p>

              <p className="mt-3 md:text-[20px] text-[17px] text-gray-300 ">
                {work.description.split("\n").map((paragraph, index) => (
                  <p key={index} className="mt-2">
                    {paragraph}
                  </p>
                ))}
              </p>
            </div>

            <div className="">
              <p className="work__detail-btext">Code technologies and skills</p>

              <ul className="work__detail-techs">
                {technologies &&
                  technologies.map((tech) => (
                    <li className="" key={tech.id}>
                      {tech.name}
                    </li>
                  ))}
              </ul>
            </div>
            <div className="w-full flex items-center justify-center p-3 mt-9"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default WorkDetail;
